import * as React from 'react';
import { connect } from 'react-redux';

import DeliverableMediaForInsights from '../../../media/parts/media-for-insights/DeliverableMediaForInsights';
import DeliverableAttachmentUploader from 'modules/deliverables/components/deliverable-v2/deliverable-attachment-uploader/DeliverableAttachmentUploader';

import {
  deleteAttachment,
  replaceAttachment,
  updateCanEditAndNotify
} from '../../redux/actions';

import { getTempNumericalId } from 'utils/id';

import {
  Deliverable,
  State
} from 'types';
import { Attachment } from '../../types/general';

interface OwnProps {
  deliverableId: number, // eslint-disable-line react/no-unused-prop-types
  snippetId: number, // eslint-disable-line react/no-unused-prop-types
  attachment: Attachment,
  type: 'highres' | 'analytics'
}

interface StateProps {
  deliverable: Deliverable,
  canEdit: boolean
}

interface DispatchProps {
  dispatchAllowEdit: () => void,
  dispatchDeleteAttachment: (a: Attachment) => void,
  dispatchReplaceAttachment: (a: Attachment, replaceId: number) => void
}

type Props = OwnProps & StateProps & DispatchProps;

const StoryArrachment = ({
  attachment,
  deliverable,
  canEdit,
  type,
  dispatchAllowEdit,
  dispatchDeleteAttachment,
  dispatchReplaceAttachment
}: Props) => (
  <DeliverableMediaForInsights
    attachment={attachment}
    deliverable={deliverable}
    isEditMode={canEdit}
    onEditModeToggled={dispatchAllowEdit}
    onDeleteAttachments={val => dispatchDeleteAttachment({
      ...val[0],
      id: Number(val[0].id)
    })}
    onReplaceAttachment={
      (replacement, current) => dispatchReplaceAttachment({
        ...replacement,
        id: getTempNumericalId()
      }, Number(current.id))
    }
    renderReplacementUploader={({ onUpdate }, forwardedRef) => (
      <DeliverableAttachmentUploader
        isReplacement
        size="custom"
        deliverable={deliverable}
        attachmentType={type}
        onUpdate={onUpdate}
        forwardedRef={forwardedRef}
      />
    )}
  />
);

const mapStateToProps = (
  { storySnippets }: State,
  { deliverableId }: OwnProps
): StateProps => ({
  canEdit: !!storySnippets.deliverables[deliverableId]?.canEdit,
  deliverable: storySnippets.deliverables[deliverableId]?.deliverable ?? {}
});

const mapDispatchToProps = (
  dispatch,
  { deliverableId, snippetId }: OwnProps
): DispatchProps => ({
  dispatchAllowEdit: () => dispatch(updateCanEditAndNotify(deliverableId, true)),
  dispatchDeleteAttachment: attachment => dispatch(deleteAttachment(
    attachment.id,
    deliverableId,
    snippetId
  )),
  dispatchReplaceAttachment: (attachment, replaceId) => dispatch(
    replaceAttachment(
      deliverableId, attachment, replaceId, snippetId
    )
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(StoryArrachment);
